import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import user2 from "../../images/ic_no_person_photo.svg";
import { FaRegEdit } from "react-icons/fa";
import { base_url_image_view_api } from "../../utils/ImageViewingAPI";
import { toast } from "react-toastify";
import axios from "axios";
import { base_url as base_url_from_axios_config } from "../../utils/AxiosConfig";
import { FaSearch } from "react-icons/fa";
import dayjs from "dayjs";
import { Tooltip } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Radio from "@mui/material/Radio";
import {
  FaCarSide,
  FaEdit,
  FaEye,
  FaFileExport,
  FaPrint,
} from "react-icons/fa";
import { MdGavel } from "react-icons/md";

const FleetList = () => {
  const [selectedValue, setSelectedValue] = useState("active");

  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const today = new Date().toISOString().split("T")[0];

  const [dateOfJoin, setDateOfJoin] = useState(null);

  const [filteredData, setFilteredData] = useState([]);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  const companyCode = storedUserDataArray[0]?.cmpcode || null;

  const [base_url] = useState(base_url_from_axios_config);

  useEffect(() => {
    fetchFleetList();
  }, []);

  const fetchFleetList = async () => {
    try {
      const response = await axios.get(
        `${base_url}/api/cpayscount/${companyCode}/VEHICLELIST/-/${selectedValue}`,
      );
      const data = response.data;
      // console.log("fetching Fleet List Complete:", data);
      setFilteredData(data);
    } catch (error) {
      console.error("Error while fetching Fleet List:", error);
    }
  };

  const formatDateWithExpiry = (date) => {
    if (!date) return <span>-</span>;

    const parsed = new Date(date);
    if (isNaN(parsed)) return <span>-</span>;

    const isExpired = parsed < new Date();

    return (
      <span className={isExpired ? "text-red-600 font-medium" : ""}>
        {parsed.toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })}
      </span>
    );
  };

  const onRecordSelect = (records) => {
    // console.log("records:", records);
    setSelectedEmployee(records);
    // getStatusData(records.EmpId);

    const formattedDate = records?.JoinDate
      ? records.JoinDate.split("T")[0]
      : "";

    setDateOfJoin(formattedDate);
  };

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  useEffect(() => {
    fetchFleetList();
  }, [selectedValue]);

  const navigate = useNavigate();

  const onNewVehicle = () => {
    navigate("/admin/fleetInformation");
  };
  const onEditVehicle = () => {
    // console.log("Selected Employee:", selectedEmployee);
    navigate("/admin/fleetInformation", { state: { item: selectedEmployee } });
  };

  const handleExport = () => {
    const columns = [
      { field: "SERIALNO", headerName: "Serial No" },
      { field: "REG_NO", headerName: "Reg No" },
      { field: "STATUS", headerName: "Status" },
      { field: "TYPE", headerName: "Type" },
      { field: "MAKE", headerName: "Make" },
      { field: "MODEL", headerName: "Model" },
      { field: "REGISTRAION ON", headerName: "Reg On" },
      { field: "REG_EXPIRY", headerName: "Reg Expiry" },
      { field: "ENGINE NO", headerName: "Engine No" },
      { field: "ODOMENTER", headerName: "Odometer" },
      { field: "PURCHASE_AMOUNT", headerName: "Purchase Amt" },
      { field: "CURRENT_CUSTODIAN", headerName: "Current Custodian" },
      { field: "ACCOUNTNO", headerName: "Account No" },
      { field: "DEPARTMENT", headerName: "Department" },
      { field: "INSURANCE EXPIRY", headerName: "Insurance Expiry" },
      { field: "INS_COMPANY", headerName: "Insurance Company" },
      { field: "PREMIUM", headerName: "Premium" },
    ];

    exportToCSV(columns, filteredData, "Fleet_List_Reports");
  };

  const exportToCSV = (columns, exportData, exportFileName = "export") => {
    if (!columns || !exportData || exportData.length === 0) return;

    const headerRow = columns.map((col) => col.headerName);

    const dataRows = exportData.map((row) =>
      columns.map((col) => {
        let value = row[col.field] ?? "";

        if (
          col.field === "REGISTRAION ON" &&
          col.field === "REG_EXPIRY" &&
          col.field === "INSURANCE EXPIRY" &&
          value
        ) {
          value = dayjs(value).format("DD/MM/YYYY");
        }

        return `"${String(value).replace(/"/g, '""')}"`;
      }),
    );

    const csvContent = [headerRow, ...dataRows]
      .map((row) => row.join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", `${exportFileName}.csv`);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const onPrint = () => {
    // console.log("Print is clicked");
    navigate("/admin/fleetListPrint", {
      state: {
        filteredData,
      },
    });
  };

  return (
    <>
      <div className="flex justify-between items-center mb-4 flex-wrap gap-3">
        {/* LEFT TITLE */}
        <div className="flex items-center">
          <div className="w-1 h-8 bg-gradient-to-r from-[#2663EB] to-blue-400 rounded-full mr-2"></div>

          <h6 className="text-xl font-bold text-gray-900">
            <span className="bg-gradient-to-r from-[#2663EB] to-blue-600 bg-clip-text text-transparent">
              FLEET LIST
            </span>
          </h6>
        </div>

        {/* RADIO FILTER */}
        <div className="flex items-center gap-2 text-sm font-medium text-gray-700">
          <label className="flex items-center gap-1 cursor-pointer">
            <Radio
              checked={selectedValue === "active"}
              onChange={handleChange}
              value="active"
              name="radio-buttons"
            />
            Active
          </label>

          <label className="flex items-center gap-1 cursor-pointer">
            <Radio
              checked={selectedValue === "inactive"}
              onChange={handleChange}
              value="inactive"
              name="radio-buttons"
            />
            Inactive
          </label>

          {/* <label className="flex items-center gap-1 cursor-pointer">
            <Radio
              checked={selectedValue === "all"}
              onChange={handleChange}
              value="all"
              name="radio-buttons"
            />
            All
          </label> */}
        </div>

        {/* ACTION BUTTONS */}
        <div className="flex items-center gap-2 flex-wrap">
          {/* New Vehicle */}
          <button
            onClick={onNewVehicle}
            className="flex items-center gap-2 px-3 py-1.5 text-sm bg-green-500 text-white rounded-md hover:bg-green-600"
          >
            <FaCarSide />
            New Vehicle
          </button>

          {/* Modify / View */}
          <Tooltip title={!selectedEmployee ? "Please select a vehicle" : ""}>
            <span>
              <button
                onClick={onEditVehicle}
                disabled={!selectedEmployee}
                className="flex items-center gap-2 px-3 py-1.5 text-sm bg-blue-500 text-white rounded-md hover:bg-blue-600 disabled:bg-gray-300 disabled:text-gray-500"
              >
                <FaEdit />
                Modify / View
              </button>
            </span>
          </Tooltip>

          {/* Fines */}
          {/* <button className="flex items-center gap-2 px-3 py-1.5 text-sm bg-red-500 text-white rounded-md hover:bg-red-600">
            <MdGavel />
            View Fines
          </button> */}

          {/* Export */}
          <button
            onClick={handleExport}
            className="flex items-center gap-2 px-3 py-1.5 text-sm bg-indigo-500 text-white rounded-md hover:bg-indigo-600"
          >
            <FaFileExport />
            Export
          </button>

          {/* Print */}
          <button
            onClick={onPrint}
            className="flex items-center gap-2 px-3 py-1.5 text-sm bg-gray-700 text-white rounded-md hover:bg-gray-800"
          >
            <FaPrint />
            Print
          </button>
        </div>
      </div>
      <div className="flex gap-4  ">
        {/* Fleet List */}

        <div className="  w-full ">
          <div className=" flex  items-center justify-left gap-12 mb-2">
            {/* <div className="bg-white w-[400px] flex items-center gap-2 p-2  border border-gray-700 rounded-md transition-all duration-200  focus-within:ring-2 focus-within:ring-[#2663EB]/20 hover:shadow-md">
              <FaSearch className="text-gray-400 text-sm transition-colors duration-200 group-focus-within:text-[#2663EB]" />

              <input
                type="text"
                placeholder="Search By ID or Name..."
                value={searchdata}
                onChange={(e) => setSearchData(e.target.value)}
                className="w-full bg-white outline-none text-sm text-gray-700 placeholder-gray-400"
              />

              {searchdata && (
                <button
                  onClick={() => setSearchData("")}
                  className="text-gray-400 hover:text-red-500 text-sm transition-colors"
                >
                  ✕
                </button>
              )}
            </div> */}

            {/* Filters */}
            {/* <div className="flex gap-2 mb-2"> */}
            {/* <select className="border px-2 py-1 text-sm">
                 <option>Division</option>
               </select>
   
               <select className="border px-2 py-1 text-sm">
                 <option>Dept</option>
               </select> */}
            {/* </div> */}
          </div>

          {/* Employee Table */}
          <div className="overflow-auto  max-h-[40vh]  border scrollbar-none bg-white rounded-md ">
            <table className="min-w-full border-separate border-spacing-0">
              <thead className="sticky top-0 z-10">
                <tr className="bg-[#2663EB] text-white text-sm">
                  <th className="px-3 py-2 font-medium text-left">Sl No</th>
                  <th className="px-3 py-2 font-medium text-left">Reg No</th>
                  <th className="px-3 py-2 font-medium text-left">Status</th>
                  <th className="px-3 py-2 font-medium text-left">Type</th>
                  <th className="px-3 py-2 font-medium text-left">Make</th>
                  <th className="px-3 py-2 font-medium text-left">Model</th>
                  <th className="px-3 py-2 font-medium text-left">Reg On</th>
                  <th className="px-3 py-2 font-medium text-left">
                    Reg Expiry
                  </th>
                  <th className="px-3 py-2 font-medium text-left">Engine No</th>
                  <th className="px-3 py-2 font-medium text-left">Odometer</th>
                  <th className="px-3 py-2 font-medium text-left">
                    Purchase Amt
                  </th>
                  <th className="px-3 py-2 font-medium text-left">
                    Current Custodian
                  </th>
                  <th className="px-3 py-2 font-medium text-left">
                    Account No
                  </th>
                  <th className="px-3 py-2 font-medium text-left">
                    Department
                  </th>
                  <th className="px-3 py-2 font-medium text-left">
                    Insurance Expiry
                  </th>
                  <th className="px-3 py-2 font-medium text-left">
                    Insurance Company
                  </th>
                  <th className="px-3 py-2 font-medium text-left">Premium</th>
                </tr>
              </thead>

              <tbody className="text-sm text-gray-700">
                {filteredData?.map((d, i) => (
                  <tr
                    key={i}
                    className={`border  transition-colors duration-150 ${selectedEmployee == d ? "bg-blue-50 " : "hover:bg-gray-50"}`}
                    onClick={() => onRecordSelect(d)}
                  >
                    <td className="px-3 py-2 whitespace-nowrap border border-gray-100">
                      {/* {i + 1} */}
                      {d?.SERIALNO}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap border ">
                      {d?.REG_NO}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap border">
                      {d?.STATUS}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap border">
                      {d?.TYPE}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap border">
                      {d?.MAKE}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap border">
                      {d?.MODEL}
                    </td>

                    <td className="px-3 py-2 whitespace-nowrap border">
                      {dayjs(d["REGISTRAION ON"]).format("DD-MMM-YYYY ")}
                    </td>

                    <td className="px-3 py-2 whitespace-nowrap border">
                      {dayjs(d?.REG_EXPIRY).format("DD-MMM-YYYY ")}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap border">
                      {d["ENGINE NO"]}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap border">
                      {d?.ODOMENTER}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap border">
                      {d?.PURCHASE_AMOUNT}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap border">
                      {d?.CURRENT_CUSTODIAN}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap border">
                      {d?.ACCOUNTNO}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap border">
                      {d?.DEPARTMENT}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap border">
                      {dayjs(d["INSURANCE EXPIRY"]).format("DD-MMM-YYYY ")}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap border">
                      {d?.INS_COMPANY}
                    </td>
                    <td className="px-3 py-2 whitespace-nowrap border">
                      {d?.PREMIUM}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default FleetList;
